import { PaginatedRequestParams } from "api";


export enum NotificationsListsFilterFormField {
  DELIVERYTYPE = 'DeliveryType',
  TITLE = 'Title',
  TEMPLATE = 'TemplateName',
  EVENTID = 'EventId',
  CATEGORYID = 'TicketCategoryId'
}


export type NotificationListsFilterFormValues = {
  [NotificationsListsFilterFormField.TEMPLATE]: string | undefined;
  [NotificationsListsFilterFormField.TITLE]: string | undefined;
  [NotificationsListsFilterFormField.DELIVERYTYPE]: any;
  [NotificationsListsFilterFormField.EVENTID]: any;
  [NotificationsListsFilterFormField.CATEGORYID]: any;
};

export enum NotificationDetailsFilterFormField {
  ID = 'NotificationId',
  CustomerName = 'customerName',
  is_active = 'status',
  DeliveryType = 'DeliveryType'
}


export type NotificationDetailsFilterFormValues = {
  [NotificationDetailsFilterFormField.ID]: number | undefined;
  [NotificationDetailsFilterFormField.CustomerName]: string[] | undefined;
  [NotificationDetailsFilterFormField.is_active]: string[] | undefined;
  [NotificationDetailsFilterFormField.DeliveryType]: string[] | undefined;

};

export type NotificationDetailsFilterFormValuesPaginated = NotificationDetailsFilterFormValues &
  PaginatedRequestParams;


export enum NotificationFilterFormField {
  ID = 'id',
  TITLE = 'title',
  is_active = 'is_active'
}

export enum NotificationFilterFormFieldList {
  ID = 'id',
  TITLE = 'title',
  CONTENT = 'content',
  ANNOUNCEMENTTYPEID = 'announcement_type_id',
  ACTIVE = "is_active",
  CATEGORYNAME = "eventCategoryIds",
  DELIVERYTYPE = "deliveryType",
  
  NOTIFICATIONLANGUAGE = "language_type",
  AGEGROUP = "ageGroupIds",
  GENDER = "gender",
  EMAIL = 'emailId',
  SPORTTYPE = "sportsTypeIds",
  EVENTNAME = "eventIds",
  SCHEDULEDATE = "schedule_date",
  SCHEDULETIME = "schedule_time",
  PAYMENT_STATUS="paymentStatus"
}

export enum NotificationCustomerFilterFormField {
  SportCategoryIds = 'SportCategoryIds',
  EventIds = 'EventIds',
  TicketCategoryIds = 'TicketCategoryIds',
  AgeGroupIds = 'AgeGroupIds',
  GenderId = 'GenderId',
  Email = 'emailId',
  Nationality = 'Nationality',
  CustomerSearch = 'CustomerName',
  CustomerTypeId = 'customertype',
  SessionId = 'SessionId',
  PAYMENT_STATUS="paymentStatus"


}

export type NotificationCustomerFilterFormValues = {

  [NotificationCustomerFilterFormField.SportCategoryIds]: string[] | undefined;
  [NotificationCustomerFilterFormField.EventIds]: string[] | undefined;
  [NotificationCustomerFilterFormField.TicketCategoryIds]: string[] | undefined;
  [NotificationCustomerFilterFormField.AgeGroupIds]: string[] | undefined;
  [NotificationCustomerFilterFormField.GenderId]: string | undefined;
  [NotificationCustomerFilterFormField.Email]: string | undefined;
  
  [NotificationCustomerFilterFormField.PAYMENT_STATUS]: string | undefined;

  [NotificationCustomerFilterFormField.Nationality]: string | undefined;
  [NotificationCustomerFilterFormField.CustomerSearch]: string | undefined;
  [NotificationCustomerFilterFormField.CustomerTypeId]: string | undefined;
  [NotificationCustomerFilterFormField.SessionId]: string | undefined;


};

export type SAVENotificationCustomerFilterFormValues = {
  [NotificationCustomerFilterFormField.SportCategoryIds]: string | undefined;
  [NotificationCustomerFilterFormField.EventIds]: string | undefined;
  [NotificationCustomerFilterFormField.TicketCategoryIds]: string | undefined;
  [NotificationCustomerFilterFormField.AgeGroupIds]: string | undefined;
  [NotificationCustomerFilterFormField.GenderId]: string | undefined;
  [NotificationCustomerFilterFormField.Email]: string | undefined;
 [NotificationCustomerFilterFormField.PAYMENT_STATUS]: string | undefined;
  [NotificationCustomerFilterFormField.Nationality]: string | undefined;
  [NotificationCustomerFilterFormField.CustomerSearch]: string | undefined;
  [NotificationCustomerFilterFormField.CustomerTypeId]: string | undefined;
  [NotificationCustomerFilterFormField.SessionId]: string | undefined;
};


export type NotificationCustomerList = {
  ParticipantId: number;
  EventID: number;
  EventName: string;
  Email: string;
  FirstName: string;
  LastName: string;
  BookingId: string;
  ParticipantNo: string;
  UserType: string;
  Age: number;
  Gender: string;

  SportCategoryId: number;
  SportCategoryName: string;
  TicketCategoryName: string;
  UserId: number;
};

export enum NotificationTemplateFilterFormFieldList {
  ID = 'Id',
  TITLE = 'Title',
  TITLEAR = 'TitleAr',
  ANNOUNCEMENTTYPEID = 'AnnouncementType',
  CONTENTEN = 'ContentEn',
  CONTENTAR = 'ContentAr',
  IMAGE = 'Image',
  IMAGEAR = 'ImageAr',
  IMAGEURL = 'ImageUrl',
  ImageUrlAr='ImageUrlAr',
  SCHEDULEDATE = "ScheduleDateTime",
  SCHEDULETIME = "schedule_time",
  DELIVERYTYPE = "deliveryType",
  TEMPLATEID = "templateId",
  ISINSTANT = "IsInstant",
  SESSIONID = "SessionId",
  TEMPLATENAME = "TemplateName",
  RedirectionUrl="RedirectionUrl",
}


// export enum SendFirebaseNotificationFormFieldList {
//   ID = 'Id',
//   TITLE = 'Title',
//   TITLEAR= 'TitleAr',
//   ANNOUNCEMENTTYPEID='AnnouncementType',
//   CONTENTEN='ContentEn',
//   CONTENTAR='ContentAr',
//   IMAGE='Image',
//   IMAGEURL='ImageUrl',


// }


export type NotificationTemplateFilterFormValues = {
  [NotificationTemplateFilterFormFieldList.ID]: string | undefined;
  [NotificationTemplateFilterFormFieldList.TITLE]: string | undefined;
  [NotificationTemplateFilterFormFieldList.TITLEAR]: string | undefined;
  [NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID]: string | undefined;
  [NotificationTemplateFilterFormFieldList.CONTENTEN]: string | undefined;
  [NotificationTemplateFilterFormFieldList.CONTENTAR]: string | undefined;
  [NotificationTemplateFilterFormFieldList.IMAGE]: any | undefined;
  [NotificationTemplateFilterFormFieldList.IMAGEAR]: any | undefined;
  [NotificationTemplateFilterFormFieldList.IMAGEURL]: string | undefined;
  [NotificationTemplateFilterFormFieldList.ImageUrlAr]: string | undefined;
  [NotificationTemplateFilterFormFieldList.TEMPLATEID]: number | null;
  [NotificationTemplateFilterFormFieldList.TEMPLATENAME]: string | undefined;
  [NotificationTemplateFilterFormFieldList.RedirectionUrl]: string | undefined;
  [NotificationTemplateFilterFormFieldList.SCHEDULEDATE]?: any;
  [NotificationTemplateFilterFormFieldList.DELIVERYTYPE]?: number;
  


};

export type SendFirebaseNotificationFilterFormValues = {
  [NotificationTemplateFilterFormFieldList.ID]: string | undefined;
  [NotificationTemplateFilterFormFieldList.TITLE]: string | undefined;
  [NotificationTemplateFilterFormFieldList.TITLEAR]: string | undefined;
  [NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID]: string | undefined;
  [NotificationTemplateFilterFormFieldList.CONTENTEN]: string | undefined;
  [NotificationTemplateFilterFormFieldList.CONTENTAR]: string | undefined;
  [NotificationTemplateFilterFormFieldList.IMAGE]: any | undefined;
  [NotificationTemplateFilterFormFieldList.IMAGEURL]: string | undefined;
  [NotificationTemplateFilterFormFieldList.ImageUrlAr]: string | undefined;

  [NotificationTemplateFilterFormFieldList.SCHEDULEDATE]: string | undefined;
  [NotificationTemplateFilterFormFieldList.SCHEDULETIME]: string | undefined;

};



export type NotificationFilterFormValues = {
  [NotificationFilterFormField.ID]: string | undefined;
  [NotificationFilterFormField.TITLE]: string | undefined;
  [NotificationFilterFormField.is_active]: any;

};
export type NotificationFilterFormValueslist = {
  [NotificationFilterFormFieldList.ID]: string | undefined;
  [NotificationFilterFormFieldList.TITLE]: string | undefined;
  [NotificationFilterFormFieldList.ANNOUNCEMENTTYPEID]: string | undefined;
  [NotificationFilterFormFieldList.ACTIVE]: any;
  [NotificationFilterFormFieldList.CATEGORYNAME]: any;
  [NotificationFilterFormFieldList.EVENTNAME]: any;
  [NotificationFilterFormFieldList.SPORTTYPE]: any;
  [NotificationFilterFormFieldList.GENDER]: any;
  [NotificationFilterFormFieldList.AGEGROUP]: any;
  [NotificationFilterFormFieldList.NOTIFICATIONLANGUAGE]: any;
  [NotificationFilterFormFieldList.DELIVERYTYPE]: any;
  [NotificationFilterFormFieldList.SCHEDULEDATE]: any;
  [NotificationFilterFormFieldList.SCHEDULETIME]: any;
  [NotificationFilterFormFieldList.PAYMENT_STATUS]: any;


};
export type NotificationFilterFormValuesPaginated = NotificationFilterFormValues &
  PaginatedRequestParams;

export type NotificationListsFilterFormValuesPaginated = NotificationListsFilterFormValues &
  PaginatedRequestParams;


export type NotificationTemplateFilterFormValuesPaginated = NotificationTemplateFilterFormValues &
  PaginatedRequestParams;

export type NotificationCustomerFilterFormValuesPaginated = SAVENotificationCustomerFilterFormValues &
  PaginatedRequestParams;